import { Outlet } from "react-router-dom"

const DriversLayout = () => {
  return <Outlet />
}

export default DriversLayout
